import {GetTitleResponse, useTitle} from '@app/titles/requests/use-title';
import {PageStatus} from '@common/http/page-status';
import {PageMetaTags} from '@common/http/page-meta-tags';
import {Fragment, useEffect, useState} from 'react';
import {TitlePageMainContent} from '@app/titles/pages/title-page/title-page-main-content';
import {TitlePageHeaderImage} from '@app/titles/pages/title-page/title-page-header-image';
import {SitePageLayout} from '@app/site-page-layout';
import {Nav, Tab} from 'react-bootstrap';
import {TruncatedDescription} from '@common/ui/truncated-description';
import {TitlePageReviewList} from './sections/title-page-review-list';
import {useAuth} from '@common/auth/use-auth';
import {ChipList} from '@common/ui/forms/input-field/chip-field/chip-list';
import {Chip} from '@common/ui/forms/input-field/chip-field/chip';
import {getGenreLink} from '@app/titles/genre-link';
import {Link} from 'react-router-dom';
import {Trans} from '@common/i18n/trans';
import {TitlePageCast} from './sections/title-page-cast';
import {TitlePageVideoGrid} from './sections/title-page-video-grid';
import {TitlePageImageGrid} from './sections/title-page-image-grid';
import {TitlePageEpisodeGrid} from './sections/title-page-episode-grid';
import {ArrowForwardIcon} from '@common/icons/material/ArrowForward';
import {CompactCredits} from '@app/titles/compact-credits';
import {useThemeSelector} from '@common/ui/themes/theme-selector-context';
import clsx from 'clsx';
import {TitlePageSources} from './sections/title-page-sources';
// import {BASE_VIDEO_SRC} from '@common/http/query-client';
import {IconButton} from '@common/ui/buttons/icon-button';
import {EditIcon} from '@common/icons/material/Edit';
import {AdHost} from '@common/admin/ads/ad-host';
import {useSelectedLocale} from '@common/i18n/selected-locale';
import {apiClient} from '@common/http/query-client';
import {Title} from '@app/titles/models/title';
import {getTitleLink} from '@app/titles/title-link';
import {ShareMenuTrigger} from '@app/sharing/share-menu-trigger';
import {Button} from '@common/ui/buttons/button';
import {ShareIcon} from '@common/icons/material/Share';
import { RWebShare } from 'react-web-share';

export function TitlePage() {
  const query = useTitle('titlePage');

  const content = query.data ? (
    <Fragment>
      <PageMetaTags query={query} />
      <PageContent data={query.data} />
    </Fragment>
  ) : (
    <PageStatus query={query} loaderClassName="absolute inset-0 m-auto" />
  );

  return <SitePageLayout>{content}</SitePageLayout>;
}

interface PageContentProps {
  data: GetTitleResponse;
}
function PageContent({data}: PageContentProps) {
  const {hasPermission, isLoggedIn} = useAuth();
  const {selectedTheme} = useThemeSelector();
  const {locale} = useSelectedLocale();

  const [isShow, setIsShow] = useState<boolean>(false);
  const [selectedEp, setSelectedEp] = useState<number | string>(0);

  // console.log(data);

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  //   if (isLoggedIn) {
  //     const video: HTMLVideoElement = document.querySelector(
  //       '.vidoePlayerSrc',
  //     ) as HTMLVideoElement;
  //     if (video) {
  //       video.src = `${import.meta.env.VITE_BASE_VIDEO_SRC}${data.title.download_links[0].link}`;
  //     }
  //     if (typeof selectedEp === 'string') {
  //       video.src = selectedEp;
  //       video?.load();
  //       video.addEventListener(
  //         'canplay',
  //         () => {
  //           video
  //             .play()
  //             .then(res => setIsShow(true))
  //             .catch(error => {
  //               console.error('Error playing video:', error);
  //             });
  //         },
  //         {once: true},
  //       );
  //     }
  //   }
  // }, [selectedEp]);

  useEffect(() => {
    apiClient.get(`sync/imdb/title/rate/${data?.title?.id}`);
  }, [data]);

  return (
    <Fragment>
      <TitlePageHeaderImage
        domain={data.domain}
        title={data.title}
        isLoggedIn={isLoggedIn}
        epId={selectedEp}
        isShow={isShow}
      />
      <div className="container relative mx-124 px-14 md:px-24 [@media(max-width:767px)]:mx-12">
        <div className="items-start gap-54 md:flex">
          {/* <TitlePageAside data={data} className="max-lg:hidden" /> */}
          <div className="mb-48 flex-auto">
            {/* <TitlePageHeader title={data.title} /> */}
            {data.title?.genres?.length ? (
              <ChipList className="my-12">
                {data.title.genres.map(genre => (
                  <Chip
                    className="trending-list text-capitalize !bg-[#e5091426] text-base font-extrabold capitalize !text-[#E50914]"
                    elementType={Link}
                    to={getGenreLink(genre)}
                    key={genre.id}
                  >
                    <Trans message={genre.display_name || genre.name} />
                  </Chip>
                ))}
              </ChipList>
            ) : null}
            <div className="flex w-full gap-x-8 border-t">
              <CompactCredits credits={data?.credits} isInTitle />
              {hasPermission('titles.update') && (
                <IconButton
                  elementType={Link}
                  to={`/admin/titles/${data?.title?.id}/edit`}
                  // className="absolute bottom-6 right-4"
                  color="white"
                >
                  <EditIcon />
                </IconButton>
              )}
            </div>
            <AdHost slot="general_bottom" className="my-10 py-24" />
            <Tab.Container defaultActiveKey="first">
              <Nav
                className={clsx(
                  'iq-custom-tab  d-flex nav nav-pills align-items-center justify-content-center list-inline mb-5 mt-5 text-center',
                  selectedTheme.is_dark ? 'tab-bg-gredient-center' : 'bg-white',
                )}
              >
                <Nav.Item>
                  <Nav.Link
                    eventKey="first"
                    id="nav-description-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-description"
                    type="button"
                    role="tab"
                    aria-controls="nav-description"
                    aria-selected="true"
                    className={clsx(selectedTheme.is_dark ? '' : 'text-black')}
                  >
                    <Trans message="Description" />
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    eventKey="fifth"
                    id="nav-cast-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-sources"
                    type="button"
                    role="tab"
                    aria-controls="nav-sources"
                    aria-selected="false"
                    className={clsx(selectedTheme.is_dark ? '' : 'text-black')}
                  >
                    <Trans message="Cast & Crew" />
                  </Nav.Link>
                </Nav.Item>
                {isLoggedIn && (
                  <Nav.Item>
                    <Nav.Link
                      eventKey="fourth"
                      id="nav-sources-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-sources"
                      type="button"
                      role="tab"
                      aria-controls="nav-sources"
                      aria-selected="false"
                      className={clsx(
                        selectedTheme.is_dark ? '' : 'text-black',
                      )}
                    >
                      <Trans message="Sources" />
                    </Nav.Link>
                  </Nav.Item>
                )}
                {/* {isLoggedIn && (
                  <Nav.Item>
                    <Nav.Link
                      eventKey="second"
                      id="nav-review-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-review"
                      type="button"
                      role="tab"
                      aria-controls="nav-review"
                      aria-selected="false"
                      className={clsx(
                        selectedTheme.is_dark ? '' : 'text-black',
                      )}
                    >
                      <Trans message="Rate & Review" />
                    </Nav.Link>
                  </Nav.Item>
                )} */}

                {data.title?.is_series && isLoggedIn && (
                  <Nav.Item>
                    <Nav.Link
                      eventKey="third"
                      id="nav-sources-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-sources"
                      type="button"
                      role="tab"
                      aria-controls="nav-sources"
                      aria-selected="false"
                      className={clsx(
                        selectedTheme.is_dark ? '' : 'text-black',
                      )}
                    >
                      <Trans message="Seasons" />
                    </Nav.Link>
                  </Nav.Item>
                )}

                <Nav.Item>
                  <Nav.Link
                    eventKey="sixth"
                    id="nav-trailer-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-sources"
                    type="button"
                    role="tab"
                    aria-controls="nav-sources"
                    aria-selected="false"
                    className={clsx(selectedTheme.is_dark ? '' : 'text-black')}
                  >
                    <Trans message="Trailers" />
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    eventKey="seventh"
                    id="nav-images-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-sources"
                    type="button"
                    role="tab"
                    aria-controls="nav-sources"
                    aria-selected="false"
                    className={clsx(selectedTheme.is_dark ? '' : 'text-black')}
                  >
                    <Trans message="Images" />
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              <Tab.Content>
                <Tab.Pane
                  className=" fade show pb-4"
                  eventKey="first"
                  id="nav-description"
                  role="tabpanel"
                  aria-labelledby="nav-description-tab"
                >
                  <TruncatedDescription
                    className={clsx(
                      'mt-16',
                      selectedTheme.is_dark ? '' : 'text-black',
                    )}
                    description={
                      locale.language === 'fa' &&
                      data?.title?.persian_description
                        ? data?.title?.persian_description
                        : data?.title?.description
                    }
                  />
                  {locale.language === 'fa' && data.title.persian_tagline ? (
                    <blockquote className="mt-16">
                      “{data.title.persian_tagline}”
                    </blockquote>
                  ) : (
                    <blockquote className="mt-16">
                      “{data.title.tagline}”
                    </blockquote>
                  )}
                </Tab.Pane>
                <Tab.Pane
                  className=" fade"
                  id="nav-review"
                  eventKey="second"
                  role="tabpanel"
                  aria-labelledby="nav-review-tab"
                >
                  {hasPermission('reviews.view') ? (
                    <TitlePageReviewList title={data.title} />
                  ) : null}
                </Tab.Pane>
                <Tab.Pane
                  className=" fade"
                  id="nav-review"
                  eventKey="third"
                  role="tabpanel"
                  aria-labelledby="nav-review-tab"
                >
                  <TitlePageEpisodeGrid
                    data={data}
                    showSeasonSelector
                    onPosterClick={epId => {
                      // console.log(epId);
                      setSelectedEp(epId);
                    }}
                  />
                </Tab.Pane>
                <Tab.Pane
                  className=" fade"
                  id="nav-sources"
                  eventKey="fourth"
                  role="tabpanel"
                  aria-labelledby="nav-sources-tab"
                >
                  <TitlePageSources
                    links={data.title?.download_links}
                    isSeries={data.title.is_series}
                    onPlayClick={epId => {
                      setSelectedEp(epId);
                    }}
                  />
                </Tab.Pane>
                <Tab.Pane
                  className=" fade"
                  id="nav-sources"
                  eventKey="fifth"
                  role="tabpanel"
                  aria-labelledby="nav-sources-tab"
                >
                  <TitlePageCast credits={data.credits?.Cast} />
                </Tab.Pane>
                <Tab.Pane
                  className=" fade"
                  id="nav-sources"
                  eventKey="sixth"
                  role="tabpanel"
                  aria-labelledby="nav-sources-tab"
                >
                  <TitlePageVideoGrid title={data.title} />
                </Tab.Pane>
                <Tab.Pane
                  className=" fade"
                  id="nav-sources"
                  eventKey="seventh"
                  role="tabpanel"
                  aria-labelledby="nav-sources-tab"
                >
                  <TitlePageImageGrid
                    images={data?.title?.images
                      ?.filter(item => item.hidden !== 1)
                      ?.sort((a, b) => {
                        const order = {backdrop: 1, poster: 2, logo: 3};
                        return order[a.type] - order[b.type];
                      })}
                    count={15}
                  />
                  {data.title.images.length !== 0 && (
                    <Link
                      to="images"
                      style={{
                        backgroundColor: '#DC2626',
                        color: '#FFFFFF',
                        padding: '12px 24px',
                        borderRadius: '8px',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px',
                        transition: 'all 0.3s ease',
                        transform: 'scale(1)',
                        width: 'max-content',
                        margin: '16px auto',
                      }}
                      className="hover:scale-105 active:scale-95"
                      onMouseOver={e => {
                        e.currentTarget.style.backgroundColor = '#B91C1C';
                        e.currentTarget.style.boxShadow =
                          '0 6px 12px rgba(0, 0, 0, 0.15)';
                      }}
                      onMouseOut={e => {
                        e.currentTarget.style.backgroundColor = '#DC2626';
                        e.currentTarget.style.boxShadow =
                          '0 4px 6px rgba(0, 0, 0, 0.1)';
                      }}
                      onMouseDown={e => {
                        e.currentTarget.style.backgroundColor = '#991B1B';
                      }}
                      onMouseUp={e => {
                        e.currentTarget.style.backgroundColor = '#B91C1C';
                      }}
                    >
                      <ArrowForwardIcon />
                      <Trans message="All Images" />
                    </Link>
                  )}
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
            <TitlePageMainContent data={data} />
          </div>
        </div>
      </div>
    </Fragment>
  );
}

interface ShareButtonProps {
  title: Title;
}
function ShareButton({title}: ShareButtonProps) {
  const link = getTitleLink(title, {absolute: true});
  return (
    <ShareMenuTrigger link={link}>
      <Button
        variant="outline"
        color="primary"
        startIcon={<ShareIcon />}
        className="ml-auto mt-14 min-h-40"
      >
        <Trans message="Share" />
      </Button>
    </ShareMenuTrigger>
  );
}
